import { StyleSheet } from 'react-native'
import { ThemedValues, ThemedShared } from 'styles/themed'
import { layoutStyles } from 'styles/layout'
import { colorList } from 'utils/colors'

export const ProfileStyles = StyleSheet.create({
	profileAvatarContainer: {
		marginVertical: 20,
	},
	profileAvatar: {
		marginHorizontal: 8,
		width: 180,
		height: 180,
	},
	profileAvatarXS: {
		marginHorizontal: 8,
		width: 90,
		height: 90,
	},
	profileAvatarUpload: {
		position: 'absolute',
		alignItems: 'flex-end',
		justifyContent: 'flex-end',
		padding: ThemedShared.paddingSmall.padding
	},
	profileAvatarUploadButton: {
		width: 40,
		height: 30,
		borderWidth: 1,
		borderRadius: ThemedValues.borderRadius,
		paddingHorizontal: 5,
		backgroundColor: '#fff',
		alignItems: 'center',
		justifyContent: 'center',
	},
	profileInformation: {
		marginBottom: 20,
		...layoutStyles.containerCenter
	},
	adWarning: {
		textAlign: 'left',
		marginBottom: 16,
		color: colorList.RED.primary
	},
	
	errorHeader: {
		fontSize: 14,
		fontWeight: '700',
		color: colorList.RED.primary,
		paddingBottom: 6
	},
	errorContainer:{
		width: '100%'
	},
	errorText: {
		fontSize: 12,
		color: colorList.RED.primary
	}
})
